import router from './router'
import store from './store'
// import urlParse from 'url-parse'
// import queryString from 'querystring'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { taoke_plugin_wxapp_get_auth_url, taoke_plugin_wxapp_auth_info_save } from '@/api/extension';
import { getToken, getRoles, setToken, setRoles } from '@/utils/auth' // getToken from cookie
// import { oem_info } from '@/api'

NProgress.configure({ showSpinner: false }) // 顶部加载进度条配置

const isDev = process.env.NODE_ENV === 'development'

// 路由白名单，不需要登录也可以进入的页面路由
const whiteList = ['/404']
if (isDev) {
  whiteList.push(...[
    '/login',
    '/adminlogin',
    '/my-center',
  ])
}

function goLogin(to, next) {
  if (isDev) {
    // next({ path: '/login', query: { redirect: to.fullPath } })
    next({ path: '/login', query: { redirect: to.fullPath }, replace: true })
  }
  else {
    const redirect = process.env.VUE_APP_REDIRECT_URL + to.fullPath  // 重定向路径

    location.replace(process.env.VUE_APP_LOGIN + '/?redirect=' + encodeURIComponent(redirect))
    // location.href = process.env.VUE_APP_LOGIN + '/?redirect=' + encodeURIComponent(redirect)  // 跳到登录页
  }
}

async function handlerOEM() {
  const { state: { oem }, dispatch } = store
  if (!oem.isOEM || oem.id !== '') return// document.title = '主推'

  dispatch('GetOEM')
}

router.beforeEach(async(to, from, next) => {
  if (!store.state.oem.isOEM) {
    if (store.state.user.roles[0] == 'taoke') {
      document.title = '推广中心 - 主推网'
    } else if (store.state.user.roles[0] == 'admin') {
      document.title = '主推管理编辑后台'
    }

  }

  NProgress.start()

  await handlerOEM()
  //  是否为小程序中转,小程序中转带token
  const token = to.query.tsid
  const isWxAuthorize = !!(token && (to.path === '/extension/wxMiniProgram'))
  /* 如果是微信小程序授权 */
  if (isWxAuthorize) {
    // 设置token
    setToken(token)
    //  设置角色
    setRoles(['taoke'])
    taoke_plugin_wxapp_get_auth_url({
      tsid: token,
      redirect: 'https://admin.zhutui.cn/#/extension/wxMiniProgram?isOEM=1',
    }).then(({ data }) => {
      if (data.error_code == 0) {
        location.href = data.auth_url;
        next()
        NProgress.done()
      }
    });
  }
  /* 选单网微信回跳 */
  if (to.query.isOEM) {
    taoke_plugin_wxapp_auth_info_save({
      authorization_code: to.query.auth_code,
    }).then(({ data }) => {
      if (data.error_code === 0) {
        location.href = 'http://cms.xuandan.com/#/extension/wxMiniProgram?state=success'
        next()
        NProgress.done()
      } else {
        location.href = 'http://cms.xuandan.com/#/extension/wxMiniProgram?state=error'
        next()
        NProgress.done()
      }
    })
  }
  if (!isWxAuthorize && !to.query.isOEM) {
    if (getToken()) {
      if (['/login', '/adminlogin'].includes(to.path)) {
        next({ path: '/' })
        NProgress.done()
      }
      else {
        if (store.getters.user_id == '') {
          // 获取用户信息
          store.dispatch('GetUserInfo').then(async() => {
            const roles = getRoles() || []

            // 登录信息的roles cookie可能会被删除，会导致无限跳到404
            // 抛出异常，让用户重新登录
            if (!roles.length) {
              return Promise.reject()
            }

            if (roles.includes('taoke')) {
              // 获取cms账户信息
              await store.dispatch('GetCmsInfo')
              await store.dispatch('GetModuleNewList')
            }

            // 生成路由表
            store.dispatch('GenerateRoutes', { roles: getRoles() }).then(() => {
              router.addRoutes(store.getters.addRouters)
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成，设置replace: true，这样导航将不会留下历史记录
            })
          }).catch(() => {
            store.dispatch('FedLogOut').then(() => {
              Message.error('验证失败，请重新登录')
              goLogin(to, next)
              // next({ path: '/' })   // 会跳转到登录页
            })
          })
        }
        // 已获取用户信息直接跳页面
        else {
          next()
        }
      }
    }
    else {
      if (whiteList.includes(to.path)) {
        next()
      }
      else {
        goLogin(to, next)
      }
      NProgress.done()
    }
  }
})

router.afterEach((to) => {
  store.dispatch('GetCacheTabs')
  if(store.getters.roles.includes('taoke')) {
    store.dispatch('SetModuleNewMark', {route: to})
  }
  NProgress.done()
})